import styled from 'styled-components';
import { Container } from '../styles/Container';
import { Content } from './SectionHtml'

const AccordionItem = ({ heading, body, id}: any) => {
  return (
    <AccordionItemWrapper >
      <AccordionItemHeading aria-controls={id} title={heading}>{heading}</AccordionItemHeading>
      <AccordionItemBody
        id={id}
        dangerouslySetInnerHTML={{
          __html: body
        }}
      ></AccordionItemBody>
    </AccordionItemWrapper>
  )
}

const Accordion = ({ data }: any) => {
  const { items } = data;
  return (
    <Container>
      <Content>
        {items?.map((item: any, index: number) => {
          return (
            <AccordionItem key={index} heading={item.heading} body={item.body} id={item._metadata.uid} />
          )
        })}
      </Content>
    </Container>
  )
}

export default Accordion;

const AccordionItemWrapper = styled.details`
    position: relative;
    border-bottom: 3px solid var(--black);

    &[open] {
        summary ::after {
            transform: rotate(180deg);
        }
        div {
            display: block;
        }
    }
`;

const AccordionItemHeading = styled.summary`
    cursor: pointer;
    padding-top: 1.2rem;
    padding-right: 2rem;
    padding-bottom: 1.2rem;
    font-weight: 800;
    color: var(--black);
    transition: color var(--border);

    &::marker {
        content: none;
    }
    
    &::after {
        content: "";
        height: 1rem;
        width: 1.5rem;
        position: absolute;
        top: 1.55rem;
        right: 0;
        display: inline-block;
        background: url('/images/arrow-down.svg') no-repeat center/contain;
    }

`
const AccordionItemBody = styled.div`
    padding-bottom: 0.5rem;
    display: none;

    p {
        margin-bottom: 1.5rem;
        line-height: 1.2;
        color: var(--secondary);
    }
`;

